<template>

    <!-- Common Banner Area -->
    <RoomBookingBanner />

    <!-- Tour Booking Submission Areas -->
    <TourBookingSubmission />


</template>
<script>
import RoomBookingBanner from '@/components/hotel/RoomBookingBanner.vue'
import TourBookingSubmission from '@/components/hotel/TourBookingSubmission.vue'

export default {
    name: "RoomBookingView",
    components: {
        RoomBookingBanner, TourBookingSubmission
    }
};
</script>